



const KEY_PREFIX = "havainnot-app";
const makeStorageKey = (...args: string[]) => [KEY_PREFIX, ...args].join("__");


export const NEW_OBSERVATION_EDITS = makeStorageKey("new-observation-edits");



export const clearLocalStorage = () => {
    localStorage.removeItem(NEW_OBSERVATION_EDITS);
};